import React from 'react';
import PropTypes from 'prop-types';

/**
 * MainTop
 */
class MainTop extends React.Component {

  render() {
    const userGuideUrl = {
      K002: K002_USER_GUIDE_URL,
      K003: K003_USER_GUIDE_URL,
      K004: K004_USER_GUIDE_URL,
      K005: K005_USER_GUIDE_URL,
      K006: K006_USER_GUIDE_URL,
      K007: K007_USER_GUIDE_URL,
      K008: K008_USER_GUIDE_URL,
      K009: K009_USER_GUIDE_URL,
      K010: K010_USER_GUIDE_URL,
      K011: K011_USER_GUIDE_URL,
      K012: K012_USER_GUIDE_URL,
      K013: K013_USER_GUIDE_URL,
      K014: K014_USER_GUIDE_URL,
      K015: K013_USER_GUIDE_URL
    };

    const pathName = location.pathname.split('/');
    let url;
    if (pathName.length == 2) {
      url = FOOTER_COMMON_USER_GUIDE_URL;
    } else {
      url = userGuideUrl[pathName[1]];
    }

    return (
      <div className="sortgroup cf main_top">
        <p className="title_img" />
        <h2 className="title_left">{this.props.title}
          <a href={url} title="ヘルプ" target="_blank">
            <p className="title_help_img" />
          </a>
        </h2>
      </div>
    );
  }
}

MainTop.propTypes = {
  title: PropTypes.string.isRequired
};

export default MainTop;
